import React, { useRef, useEffect } from "react";
import { DropDownOptionsProps, DropDown } from "../../../ui/DropDown";
import { StatusIcon } from "../../../assets/svg/StatusIcon";
import { Formik, Field, Form } from "formik";
import { InputSection } from "../components/Form";
import Input from "../../../ui/Input";
import FileUploader from "../../../ui/FileUploader";
import { postEndpoint, putEndpoint } from "../../../api/api";
import { COMPANY_URL } from "../../../api/urls";
import { get } from "../../../utils/get";
import { values } from "d3";
import { toast } from "react-toastify";
import { CompanySchema } from "../../../utils/validationSchema/CompanySchema";

interface IProps {
  setHandleSubmit?: any;
  closseModal: any;
  editData?: any;
  setCompanies?: any;
  companies?: any;
}

interface FormValues {
  name: string;
  avatar: any;
  notes: string;
}

const AddCompany = ({
  setHandleSubmit,
  closseModal,
  editData,
  setCompanies,
  companies,
}: IProps) => {
  const formRef: any = useRef<any>(null);
  const [createRes, createReq] = postEndpoint();
  const [updateRes, updateReq] = putEndpoint();

  const { id } = editData;

  const isAddMode = !id;

  const handleSubmit = () => {
    if (formRef.current) {
      formRef.current.handleSubmit();
    }
  };

  useEffect(() => {
    setHandleSubmit(() => handleSubmit);
    return () => {};
  }, []);

  const addCompany = (values) => {
    const config = {
      headers: {
        "content-type": "multipart/form-data",
      },
    };
    const payload = new FormData();
    if (get(values, "avatar")) {
      payload.set("name", get(values, "name"));
      payload.append("avatar", get(values, "avatar"));
      payload.set("notes", get(values, "notes"));
    } else {
      payload.set("name", get(values, "name"));
      payload.set("notes", get(values, "notes"));
    }
    createReq(COMPANY_URL, payload, config);
  };

  const editCompany = (values) => {
    const config = {
      headers: {
        "content-type": "multipart/form-data",
      },
    };

    const payload = new FormData();
    if (get(values, "avatar")) {
      payload.set("name", get(values, "name"));
      payload.append("avatar", get(values, "avatar"));
      payload.set("notes", get(values, "notes"));
    } else {
      payload.set("name", get(values, "name"));
      payload.set("notes", get(values, "notes"));
    }

    updateReq(`${COMPANY_URL}/${id}`, payload, config);
  };

  useEffect(() => {
    if (!isAddMode) {
      const fields = ["name", "avatar", "notes"];

      fields.forEach((field) =>
        formRef.current.setFieldValue(field, editData[field], false)
      );
    }
  }, []);

  useEffect(() => {
    const { complete, pending, data, error } = createRes;
    if (error) {
      toast.error(get(data, "message.name"));
    }
    if (!pending && complete && !error) {
      closseModal();
      toast.success("Company created successfully");
    }

    return () => {};
  }, [createRes]);

  useEffect(() => {
    const { complete, pending, data } = updateRes;
    if (!pending && complete && data) {
      toast.success("Company updated successfully");
      closseModal();
    }
  }, [closseModal, companies, updateRes]);

  return (
    <Formik
      initialValues={{
        name: "",
        avatar: null,
        notes: "",
      }}
      validationSchema={CompanySchema}
      innerRef={formRef}
      onSubmit={
        isAddMode
          ? (values: FormValues) => addCompany(values)
          : (values: FormValues) => editCompany(values)
      }
    >
      {({ values }) => {
        return (
          <Form>
            <InputSection>
              <Field
                type="text"
                name="name"
                placeholder="enter company name"
                label="Company name"
                component={Input}
              />
            </InputSection>
            <InputSection>
              <Field
                type="file"
                name="avatar"
                isImage
                component={FileUploader}
                label="Avatar"
                backgroundColor="#F5F6FB"
              />
            </InputSection>

            <InputSection>
              <Field
                type="textarea"
                name="notes"
                placeholder="Description"
                label="Company description"
                component={Input}
              />
            </InputSection>
          </Form>
        );
      }}
    </Formik>
  );
};

export default AddCompany;
